import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { functions } from "@/lib/firebase";
import { toast } from 'sonner';
import Header from "@/components/Header";
import { CrosswordResponse, CrosswordCell } from '@/utils/crosswordGenerator';

interface CrosswordData extends CrosswordResponse {
  grid: CrosswordCell[][];
  acrossClues: { number: number; clue: string; answer: string }[];
  downClues: { number: number; clue: string; answer: string }[];
  title: string;
  uuid: string;
}

const SharePage = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCrossword = async () => {
      if (!uuid) {
        toast.error('Invalid crossword link');
        navigate('/');
        return;
      }

      try {
        console.log('Fetching crossword by UUID:', uuid);
        let getCrosswordByUUIDFunction;
        if(import.meta.env.MODE === 'development') {
          getCrosswordByUUIDFunction = httpsCallable<{ uuid: string }, any>(functions, 'getCrosswordByUUIDFunction');
        }
        else {
          getCrosswordByUUIDFunction = httpsCallable<{ uuid: string }, any>(functions, 'getCrosswordByUUIDFunction',{ limitedUseAppCheckTokens: true });
        }
        const result = await getCrosswordByUUIDFunction({ uuid });

        if (result.data) {
          const crosswordData = result.data.data as CrosswordData;
          // Navigate to CrosswordPage with the crossword data
          navigate('/crossword', { 
            state: {
              grid: crosswordData.grid,
              acrossClues: crosswordData.acrossClues,
              downClues: crosswordData.downClues,
              title: crosswordData.title,
              uuid: crosswordData.uuid
            }
          });
        } else {
          throw new Error('Crossword not found');
        }
      } catch (error) {
        console.error('Error fetching crossword:', error);
        toast.error('Failed to load crossword');
        navigate('/');
      } finally {
        setIsLoading(false);
      }
    };

    fetchCrossword();
  }, [uuid, navigate]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-12 flex items-center justify-center">
        {isLoading && (
          <div className="text-center">
            <h2 className="text-2xl font-semibold mb-4">Loading your crossword...</h2>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          </div>
        )}
      </main>
    </div>
  );
};

export default SharePage; 